import React, { createContext, useReducer, Fragment } from 'react';
import reducer, { makeInitialState } from './reducer';
import { useSnackbar } from 'notistack';

const initialState = makeInitialState();
const MainContext = createContext(initialState);
const { Provider } = MainContext;

export const StateProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { enqueueSnackbar } = useSnackbar();
  const showMessage = (text, color = 1, position = null) => {
    let variant = 'success';
    var anchorOrigin;
    color === 2 && (variant = 'error');
    color === 3 && (variant = 'warning');
    switch (position) {
      case 'tl':
        anchorOrigin = {
          vertical: 'top',
          horizontal: 'left',
        };
        break;
      case 'tc':
        anchorOrigin = {
          vertical: 'top',
          horizontal: 'center',
        };
        break;
      case 'tr':
        anchorOrigin = {
          vertical: 'top',
          horizontal: 'right',
        };
        break;
      case 'bl':
        anchorOrigin = {
          vertical: 'bottom',
          horizontal: 'left',
        };
        break;
      case 'bc':
        anchorOrigin = {
          vertical: 'bottom',
          horizontal: 'center',
        };
        break;
      case 'brl':
        anchorOrigin = {
          vertical: 'bottom',
          horizontal: 'right',
        };
        break;

      default:
        anchorOrigin = {
          vertical: 'bottom',
          horizontal: 'center',
        };
        break;
    }
    if (typeof text === 'object') {
      text = (
        <ul>
          {text.map((t, i) => (
            <li key={i}>{t}</li>
          ))}
        </ul>
      );
    }
    enqueueSnackbar(text, { variant, anchorOrigin });
  };
  const showError = (error, color = 2, position = 'bc') => {
    let text;
    if (typeof error === 'object') {
      if (
        (error?.response?.data?.messages) ||
        (error?.ok === false && Array.isArray(error?.messages))
      ) {
        text = error?.response?.data?.messages
          ? error.response.data.messages
          : error.messages;
      } else {
        text = 'بروز خطای غیر منتظره.';
      }
    } else if (typeof error === 'string') {
      text = error;
    }
    showMessage(text, color, position);
  };
  return (
    <Provider value={{ state, dispatch, showError, showMessage }}>
      {children}
    </Provider>
  );
};

export default MainContext;
